import { Plus, Upload } from "lucide-react";
import { useState } from "react";
import AppButton from "../../components/ui/AppButton";
import { Fine, FineHistory } from "./@types";
import FineBulkUploadModal from "./components/FineBulkUploadModal";
import FineModal from "./FineModal";
import IssueFineModal from "./IssueFineModal";
import FineHistoryDashTab from "./refactor/FineHistoryDashTab";
import FinesDashTab from "./refactor/FinesDashTab";

const FinesDashboard = () => {
  const [activeTab, setActiveTab] = useState("saved-fines");
  const [isModalOpen, setIsModalOpen] = useState("");
  const [selectedFine, setSelectedFine] = useState<Fine | null>(null);
  const [selectedFineHistory, setSelectedFineHistory] =
    useState<FineHistory | null>(null);

  const TabContent = () => {
    if (activeTab === "saved-fines") {
      return <FinesDashTab />;
    } else if (activeTab === "fine-history") {
      return <FineHistoryDashTab />;
    }
    return null;
  };

  const handleCloseModal = () => {
    setIsModalOpen("");
    setSelectedFine(null);
    setSelectedFineHistory(null);
  };

  const handleOpenModal = (modal: string) => {
    setIsModalOpen(modal);
  };

  return (
    <div className="min-h-screen py-6 w-full bg-[#F9F9F9] p-4">
      <div className="w-full mx-auto space-y-6">
        <div className="flex flex-wrap items-center justify-between gap-3 bg-white rounded-[10px] p-4">
          <div className="">
            <h2 className="text-xl font-semibold text-hColor">Fine</h2>
          </div>

          <div className="flex gap-3">
            <AppButton
              appearance="outline"
              onClick={() => setIsModalOpen("bulk")}
              className="flex items-center px-4 py-2 rounded-lg w-auto h-[38px]"
            >
              <Upload className="h-4 w-4 mr-2" />
              Bulk upload
            </AppButton>
            <AppButton
              appearance="soft"
              onClick={() => setIsModalOpen("fine-modal")}
              className="flex items-center px-4 py-2 border border-primary bg-white rounded-lg text-primary hover:bg-gray-50 transition-colors min-w-[146px] h-[38px]"
            >
              <Plus className="h-4 w-4 mr-2" />
              New fine
            </AppButton>
            <AppButton
              onClick={() => setIsModalOpen("issue-fine-modal")}
              className="flex items-center px-4 py-2 bg-primary text-white rounded-lg hover:bg-primary/60 transition-colors min-w-[146px] h-[38px]"
            >
              <Plus className="h-4 w-4 mr-2" />
              Issue fine
            </AppButton>
          </div>
        </div>

        <div className="items-center justify-between bg-white rounded-[10px] p-4">
          <div className="bg-white rounded-[10px] p-1 h-[70px] flex items-center overflow-x-auto">
            <nav className="flex px-2 whitespace-nowrap min-w-max">
              <button
                onClick={() => setActiveTab("saved-fines")}
                className={`px-3 py-1 mr-4 font-medium text-[16px] transition-colors ${
                  activeTab === "saved-fines"
                    ? "bg-primary/20 text-primary rounded-[8px]"
                    : "border-transparent text-pColor hover:text-hColor"
                }`}
              >
                Saved fines
              </button>
              <button
                onClick={() => setActiveTab("fine-history")}
                className={`px-3 py-1 mr-4 font-medium text-[16px] transition-colors ${
                  activeTab === "fine-history"
                    ? "bg-primary/20 text-primary rounded-[8px]"
                    : "border-transparent text-pColor hover:text-hColor"
                }`}
              >
                Fine history
              </button>
            </nav>
          </div>
          {/* Tab Content */}
          <div className="mt-5">
            <TabContent />
          </div>
        </div>
      </div>

      {isModalOpen === "fine-modal" && (
        <FineModal
          isOpen={isModalOpen === "fine-modal"}
          onClose={handleCloseModal}
          fine={selectedFine}
        />
      )}

      <FineBulkUploadModal
        isOpen={isModalOpen === "bulk"}
        onClose={handleCloseModal}
      />

      {isModalOpen === "issue-fine-modal" && (
        <IssueFineModal
          isOpen={isModalOpen === "issue-fine-modal"}
          onClose={handleCloseModal}
          issueFine={selectedFineHistory}
        />
      )}
    </div>
  );
};

export default FinesDashboard;
